<template>
 <el-row>
 <headertop></headertop>
 <div class="main">
  <div class="livetop">
   <div class="livetop_left">
     <img :src= 'liveList.img' />
     <div class="livetop_right_one">
       <div class="livetop_right_one_left">
         主讲人：{{liveList.teacher}}
       </div>
       <div class="livetop_right_one_right">
         开播时间：{{liveList.time}}
       </div>
     </div>
   </div>
    <div class="livetop_right">
      <h2>{{liveList.name}}</h2>
     <div class="border"></div>
      <!-- <div class="livetop_right_one">
        <div class="livetop_right_one_left">
          主讲人：{{liveList.teacher}}
        </div>
        <div class="livetop_right_one_right">
          开播时间：{{liveList.time}}
        </div>
      </div> -->
      <p style="margin-left:10px;">课程详情</p >


       <div v-html="rawHtml" style="margin-top:20px;"></div>
      <div class="livetop_right_tow">
        <!-- <div class="livetop_right_tow_left">
         {{liveList.type_price}}
        </div> -->
        <div class="livetop_right_tow_right">
          <button @click="Jump()" style="cursor: pointer;background-color: #32CD32;" v-if="type=='进行中'">{{type}}</button>
          <button @click="Jump()" style="cursor: pointer;" v-else>{{type}}</button>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="livebuttton">
     <div class="liveleft">
    <p style="margin-left:10px;">课程详情</p >
       <div class="border"></div>
     <div v-html="rawHtml" style="margin-top:20px;"></div>
  </div>
  <div class="liveright">
   <p style="margin-left:10px;">讲师信息</p >
    <div class="border"></div>
   <div class="liveright_img">
   < img :src= liveList.teacher_img  style="height: 100%;width:100%;">
   </div>
    <div class="liveright_content">{{liveList.teacher_content}}</div>
  </div>
  </div> -->
  </div>

 <el-dialog
   title="直播通道"
   :visible.sync="live_dialogVisibl.show"
   width="40%"
  >
   <el-row style="text-align: center;">
     <el-col :span="12"><el-button type="primary" @click="goTo('xet')">通道一：药知课堂<span v-if="liveList.xet=='0' || liveList.xet==''">[未开通]</span></el-button></el-col>
     <el-col :span="12"><el-button type="primary" @click="goTo('meet')">通道二：腾讯会议直播<span v-if="liveList.meet=='0' ||liveList.meet==''">[未开通]</span></el-button></el-col>
   </el-row>
   <!-- <br />
   <el-row style="text-align: center;">
     <el-col :span="12"><el-button type="primary" @click="goTo('ke')">通道三：腾讯课堂<span v-if="liveList.ke=='0' || liveList.ke==''">[未开通]</span></el-button></el-col>
   </el-row> -->
   <el-row style="margin-top: 1.875rem;">
     注意：您在使用
     <span style="color: red;">[通道二：腾讯会议直播]</span>
     时，请您确定您已经下载腾讯会议客户端
   </el-row>


   <span slot="footer" class="dialog-footer">
     <el-button @click="live_dialogVisibl.show = false">取 消</el-button>
     <!-- <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
   </span>
 </el-dialog>
 <footerbom></footerbom>
 </el-row>
</template>

<script>
    import Header from '../../../components/index/public/visitor_NavHeader.vue';
  import Footer from '../../../components/index/public/NavFooter.vue';
  export default {
    name: 'App',
    data() {
      return {
        live_dialogVisibl:{
          show:false
        },
        num:this.$route.query.num,
        liveList:[],
        type:'',
        rawHtml:''
      }
    },
    components: {
      headertop: Header,
      footerbom: Footer
    },
    mounted: function (){
      this.get_task_info();
      this.dstimers= setInterval(() => {
        this.get_task_info();
      }, 5000);
      // this.dstimers= setInterval(() => {
      //   this.setitem();
      // }, 1000);

    },
    methods: {
      goTo(type){
        let _this=this
        if(_this.liveList[type]=='0' || _this.liveList[type]==''){
          _this.$message.error("当前直播间未开放，请移至其他直播间观看");
        }else{
          window.open(_this.liveList[type])
        }
      },
      Jump(){
        let _this=this
        if(this.type=="进行中"){
          // this.$router.push({path:'/Livebroadcasting',query:{num:this.num}})
          _this.live_dialogVisibl.show=true
        }
      },
      // setitem(){
      //   let _this = this;
      //   _this.axios.get("/v2/user_live/get_living_status", {params:{'num':_this.num},}).then(function (res) {
      //     if (res.status == "200") {
      //       if (res.data.code == "1") {
      //        // _this.type=res.data.data;
      //        _this.type="进入直播"
      //        // _this.Jump()
      //       } else {
      //         _this.$message.error(res.data.msg);
      //       }
      //     } else {
      //       _this.$message.error("服务器内部错误");
      //     }
      //   });

      // },
      get_task_info(){
        let _this = this;
          _this.axios
        .get("/v2/user_live/get_info", {
          params:{'num':_this.num},
        })
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.liveList=res.data.data;
              _this.rawHtml=res.data.data.info;
              // _this.liveList.status=1

          　　let yy = new Date().getFullYear();
          　　let mm = new Date().getMonth()+1;
          　　let dd = new Date().getDate();
          　　let hh = new Date().getHours();
          　　let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
              if (mm < 10) mm = "0" + mm;
              if (dd < 10) dd = "0" + dd;
              if (hh < 10) hh = "0" + hh;
              if (mf < 10) mf = "0" + mf;
          　　let gettime = yy+'-'+mm+'-'+dd+' '+hh+':'+mf;
              if( _this.liveList.status==0){
                if(_this.liveList.time>gettime){
                  _this.type='未开始'
                }else{
                  _this.type='已结束'
                }
              }else{
                _this.type='进行中'
              }
              // _this.setitem();
              // if(_this.liveList.type_price==0){
              //   _this.liveList.type_price="免费"
              // }else{
              //   _this.liveList.type_price="付费"
              // }
            } else {
              _this.$message.error(res.data.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
    }},
    destroyed(){
      clearInterval(this.dstimers);
    }
    }
</script>

<style>
.liveright_content{
margin-top:20px;
margin-left:10px
}
.liveright_img{
margin-top:10px;
width:50%;
margin-left:20%;
height:50%;
border-radius:50%;
overflow:hidden;
}
.liveleft{
  margin-top: 20px;
  background-color: white;
  width: 60%;
  height: 400px;
  overflow:auto;
  float: left;
}
.liveright{
  margin-top: 20px;
  background-color: white;
  width: 34%;
  height: 300px;
  float: left;
  margin-left: 5%;
}
.livebuttton{
   height: 400px;
}
.livetop{
   width: 100%;
   min-height: calc(100vh - 200px);
   background-color: white;
   display: flex;


}
.main{
    min-height: calc(100vh - 330px);
    width: 70%;
    padding: 20px;
    margin: 0 15%;
    z-index: 100;

}
.livetop_left{
  flex: 1.5;
   padding: 1.25rem;
   max-height: 17.5rem;
   }
  .livetop_left img{
    width: 100%;
  }
.livetop_right{
  flex: 2;
  position:relative;
  margin-left:5%;
  margin-right:5%;
}
.border{
  width: 100%;
  height: 1px;
  background-color: darkgray;
  margin-top: 20px;
}
h2{
   display: flex;
  justify-content: center;

}
.livetop_right_one_right{
position:absolute;
right:10px;
}
.livetop_right_one_left{
 position:absolute;
}
.livetop_right_one{
  margin-top: 20px;
  position:relative;
  color:#A9A9A9;
}
.livetop_right_tow_left{
position:absolute;
color:  #32CD32;
font-size: 20px;
left:30px;

height:100%
}
.livetop_right_tow_right{
position:absolute;
right:10px;
height:100%

}
.livetop_right_tow{
  width: 100%;
  height: 10%;
  position:absolute;
  right:1.25rem;
  bottom: 1.3125rem
}
.livetop_right_tow_right button{
  height: 100%;
  width: 200px;
  color: white;
  background-color:#808080;
  border: none;
  border-radius: 3%;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/view/visitor/Live/Liveintroduce.vue